/* eslint-disable fp/no-mutation */
import type { PromotionDetails } from '@frontend/api-types';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export const PROMO_PERSISTENCE_TTL_HOURS = 72;

export type PromoReduxState = {
  promoCode?: string;
  promoDetails?: PromotionDetails;
  savedAt?: number;
};

const initialState: PromoReduxState = {};

const promoSlice = createSlice({
  initialState,
  name: 'auth',
  reducers: {
    clearPromo: (state) => {
      state.promoCode = undefined;
      state.promoDetails = undefined;
      state.savedAt = undefined;
    },
    setPromoCode: (state, { payload }: PayloadAction<string>) => {
      state.promoCode = payload;
      state.savedAt = Date.now();
    },
    setPromoDetails: (state, { payload }: PayloadAction<PromotionDetails>) => {
      state.promoDetails = payload;
    },
  },
});

export const { reducer: promoReducer } = promoSlice;
export const { clearPromo, setPromoCode, setPromoDetails } = promoSlice.actions;
